<template>
  <global-app>
    <!-- <template slot="body" v-if="navigations.active == 'surat-masuk'">
            <surat-masuk :nomorSuratMasuk="nomorSurat"></surat-masuk>
        </template>
        <template slot="body" v-if="navigations.active == 'surat-keluar'">
            <surat-keluar :nomorSuratKeluar="nomorSurat"></surat-keluar>
        </template>
        <template slot="create">
            <buku-kendali-create></buku-kendali-create>
        </template> -->
  </global-app>
</template>

<script>
export default {
  data() {
    return {
      nomorSurat: [],
      nomorSuratMasuk: [],
      nomorSuratKeluar: []
    };
  },
  computed: {
    navigations() {
      return {
        action: {
          buttonTitle: "Buat Nomor",
          to: "/buku-kendali/buat"
        },
        active: this.$route.params.filter || "surat-masuk",
        list: [
          {
            icon: "SendIcon",
            text: "Surat Keluar",
            active: "surat-keluar",
            showMobile: true,
            to: "/buku-kendali/surat-keluar",
            badge: 0,
            gql: "surat_keluar"
          },
          {
            icon: "InboxIcon",
            text: "Surat Masuk",
            active: "surat-masuk",
            showMobile: true,
            to: "/buku-kendali/surat-masuk",
            gql: "surat_masuk"
          }
        ]
      };
    }
  },
  mounted() {
    this.$store.dispatch("globalApp/setNavigations", this.navigations);
  },
  methods: {},
  watch: {
    "$store.state.globalApp.navigations.active"() {}
  }
};
</script>
